// DOM element registry for the playground.
// Each property is a lazy getter so callers can reach for the element when
// needed without worrying about boot-time ordering.

export const elements = {
  get wrapper() {
    return document.getElementById('wrapper') as HTMLElement
  },
  get mainPanel() {
    return document.getElementById('main-panel') as HTMLElement
  },
  get dvalaPanel() {
    return document.getElementById('dvala-panel') as HTMLElement
  },
  get bottomPanel() {
    return document.getElementById('bottom-panel') as HTMLElement
  },
  get rightPanel() {
    return document.getElementById('right-panel') as HTMLElement
  },
  get moreMenu() {
    return document.getElementById('more-menu') as HTMLElement
  },
  get filesHeaderMenu() {
    return document.getElementById('files-header-menu') as HTMLElement
  },
  get outputResult() {
    return document.getElementById('output-result') as HTMLElement
  },
  get dvalaEditorHost() {
    return document.getElementById('dvala-editor-host') as HTMLDivElement
  },
  get resizeDevider1() {
    return document.getElementById('resize-divider-1') as HTMLElement
  },
  get resizeDevider2() {
    return document.getElementById('resize-divider-2') as HTMLElement
  },
  get resizeDevider3() {
    return document.getElementById('resize-divider-3') as HTMLElement
  },
  get dvalaPanelDebugInfo() {
    return document.getElementById('dvala-panel-debug-info') as HTMLDivElement
  },
  get editorToolbarTitle() {
    return document.getElementById('editor-toolbar-title') as HTMLSpanElement
  },
  get editorToolbarSave() {
    return document.getElementById('editor-toolbar-save') as HTMLAnchorElement
  },
  get snapshotModal() {
    return document.getElementById('snapshot-modal') as HTMLDivElement
  },
  get snapshotPanelContainer() {
    return document.getElementById('snapshot-panel-container') as HTMLDivElement
  },
  get importOptionsModal() {
    return document.getElementById('import-options-modal') as HTMLDivElement
  },
  get importOptCode() {
    return document.getElementById('import-opt-code') as HTMLInputElement
  },
  get importOptCodeLabel() {
    return document.getElementById('import-opt-code-label') as HTMLLabelElement
  },
  get importOptContext() {
    return document.getElementById('import-opt-context') as HTMLInputElement
  },
  get importOptContextLabel() {
    return document.getElementById('import-opt-context-label') as HTMLLabelElement
  },
  get importOptSettings() {
    return document.getElementById('import-opt-settings') as HTMLInputElement
  },
  get importOptSettingsLabel() {
    return document.getElementById('import-opt-settings-label') as HTMLLabelElement
  },
  get importOptSavedSnapshots() {
    return document.getElementById('import-opt-saved-snapshots') as HTMLInputElement
  },
  get importOptSavedSnapshotsLabel() {
    return document.getElementById('import-opt-saved-snapshots-label') as HTMLLabelElement
  },
  get importOptRecentSnapshots() {
    return document.getElementById('import-opt-recent-snapshots') as HTMLInputElement
  },
  get importOptRecentSnapshotsLabel() {
    return document.getElementById('import-opt-recent-snapshots-label') as HTMLLabelElement
  },
  get importOptLayout() {
    return document.getElementById('import-opt-layout') as HTMLInputElement
  },
  get importOptLayoutLabel() {
    return document.getElementById('import-opt-layout-label') as HTMLLabelElement
  },
  get importOptWorkspaceFiles() {
    return document.getElementById('import-opt-workspace-files') as HTMLInputElement
  },
  get importOptWorkspaceFilesLabel() {
    return document.getElementById('import-opt-workspace-files-label') as HTMLLabelElement
  },
  get importResultModal() {
    return document.getElementById('import-result-modal') as HTMLDivElement
  },
  get importResultContent() {
    return document.getElementById('import-result-content') as HTMLDivElement
  },
  get exportModal() {
    return document.getElementById('export-modal') as HTMLDivElement
  },
  get exportOptCode() {
    return document.getElementById('export-opt-code') as HTMLInputElement
  },
  get exportOptContext() {
    return document.getElementById('export-opt-context') as HTMLInputElement
  },
  get exportOptSettings() {
    return document.getElementById('export-opt-settings') as HTMLInputElement
  },
  get exportOptSavedSnapshots() {
    return document.getElementById('export-opt-saved-snapshots') as HTMLInputElement
  },
  get exportOptRecentSnapshots() {
    return document.getElementById('export-opt-recent-snapshots') as HTMLInputElement
  },
  get exportOptLayout() {
    return document.getElementById('export-opt-layout') as HTMLInputElement
  },
  get exportOptWorkspaceFiles() {
    return document.getElementById('export-opt-workspace-files') as HTMLInputElement
  },
  get toastContainer() {
    return document.getElementById('toast-container') as HTMLDivElement
  },
  get executionControlBar() {
    return document.getElementById('execution-control-bar') as HTMLDivElement
  },
  get executionStatus() {
    return document.getElementById('execution-status') as HTMLSpanElement
  },
  get execPlayBtn() {
    return document.getElementById('exec-play-btn') as HTMLButtonElement
  },
  get execPauseBtn() {
    return document.getElementById('exec-pause-btn') as HTMLButtonElement
  },
  get execStopBtn() {
    return document.getElementById('exec-stop-btn') as HTMLButtonElement
  },
}
